export function isAcceptedSize(file, maxSize = -1) {
    if (maxSize <= 0 || file.size <= maxSize) {
        return true;
    }
    return false;
}
//# sourceMappingURL=is-accepted-size.js.map